<div class="batches-index-header">
  <div class="batches-index-header-block">
    <span class="batches-index-header-title">{{
      'BATCH_MAILING.TITLE' | translate
    }}</span>
    <a
      target="_blank"
      aria-labelledby="batch-mailing-title"
      href="https://belpost.by/biznesu/Drugiyeuslugi/Oformleniyepartionnykhpoc"
    >
      {{ 'BATCH_MAILING.LINK_TO_RECOMMENDATIONS' | translate }}
    </a>
  </div>

  <button
    (click)="downloadBlank()"
    [disabled]="selected?.length !== 1 || selected[0]?.status !== 'done'"
    [tooltip]="
      (selected?.length !== 1 || selected[0]?.status !== 'done'
        ? 'BATCH_MAILING.BLANKS_TAB.SELECT_TO_DOWNLOAD'
        : ''
      ) | translate
    "
    triggers="pointerenter:pointerout"
    class="button button--sm button--filled button--shadow"
  >
    {{ 'BATCH_MAILING.BLANKS_TAB.DOWNLOAD_BLANKS' | translate }}
  </button>
  <app-main-tabs></app-main-tabs>
</div>

<app-filters
  (statusChange)="onStatusChange($event)"
  (removeChange)="remove()"
  [selected]="selected"
  (searchChange)="search($event)"
></app-filters>
@if (!isLoading) {
  <app-paginator
    [items]="items"
    [localStorageKey]="'batch_items_per_page'"
    [pageSizeItemKey]="'BATCH_MAILING.BLANKS_TAB.PAGINATION_ITEM_KEY'"
    (pageChange)="pageChanged($event)"
  >
  </app-paginator>
  @if (items?.data?.length) {
    <section class="batches-index-main">
      @for (item of items.data; track item) {
        <app-blank-item
          [item]="item"
          (selected)="updateSelection()"
        ></app-blank-item>
      }
    </section>
  } @else {
    <div class="item-placeholder text-center">
      <img src="./assets/img/misc/box.svg" alt="" class="eye-d-none" />
      <p class="text-secondary">
        {{ 'BATCH_MAILING.BLANKS_TAB.NO_BLANKS_FOUND' | translate }}
      </p>
    </div>
  }
}

@if (isLoading) {
  <div class="text-secondary text-center">
    <div class="spinner-border spinner-border-lg" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
  </div>
}
